function syncHeaderMenuStyle() {
  const header = document.getElementById('header-component');
  if (!header) return;
  if (window.matchMedia('(min-width: 990px)').matches) {
    header.setAttribute('data-menu-style', 'menu');
  }
}

syncHeaderMenuStyle();
window.addEventListener('resize', syncHeaderMenuStyle);

if (!customElements.get('rb-department-bar')) {
  class RbDepartmentBar extends HTMLElement {
    /** @type {HTMLElement | null} */
    #panel;
    /** @type {NodeListOf<HTMLElement>} */
    #links;
    /** @type {number} */
    #hideTimer = 0;

    connectedCallback() {
      this.#panel = this.querySelector('[data-rb-dept-panel]');
      this.#links = this.querySelectorAll('.rb-dept-bar__link');
      this.addEventListener('pointerenter', this.#onEnter);
      this.addEventListener('pointerleave', this.#onLeave);
      this.#links.forEach((link) => {
        link.addEventListener('pointerenter', this.#onLinkEnter);
        link.addEventListener('focus', this.#onLinkEnter);
      });
    }

    disconnectedCallback() {
      this.removeEventListener('pointerenter', this.#onEnter);
      this.removeEventListener('pointerleave', this.#onLeave);
      this.#links?.forEach((link) => {
        link.removeEventListener('pointerenter', this.#onLinkEnter);
        link.removeEventListener('focus', this.#onLinkEnter);
      });
    }

    #onEnter = () => {
      window.clearTimeout(this.#hideTimer);
    };

    #onLeave = () => {
      this.#hideTimer = window.setTimeout(() => this.hide(), 160);
    };

    /**
     * @param {Event} event
     */
    #onLinkEnter = (event) => {
      if (window.matchMedia('(max-width: 749px)').matches) return;
      const link = event.currentTarget;
      if (!(link instanceof HTMLElement)) return;
      const id = link.dataset.dept;
      if (!id) {
        this.hide();
        return;
      }
      this.show(id);
    };

    /**
     * @param {string} id
     */
    show(id) {
      const nav = this.querySelector('department-nav');
      if (nav && typeof nav.select === 'function') nav.select(id);
      this.#links.forEach((link) => {
        link.classList.toggle('is-active', link.dataset.dept === id);
      });
      if (this.#panel) this.#panel.hidden = false;
    }

    hide() {
      if (this.#panel) this.#panel.hidden = true;
      this.#links.forEach((link) => link.classList.remove('is-active'));
    }
  }

  customElements.define('rb-department-bar', RbDepartmentBar);
}
